export default __webpack_public_path__ + "static/12-price-list-6c52df47fddd76c250a2363d9618dc6f.png";